<template>
  <div class="verifying-company">
    <p>法人名</p>
    <input class="text_form" type="text" v-model="companyName"/>

    <p>法人名（カナ）</p>
    <input class="text_form" type="text" v-model="company.name_kana"/>

    <p>電話番号</p>
    <input class="text_form" type="text" v-model="company.phone"/>

    <p>法人番号</p>
    <input class="text_form" type="number" v-model="company.tax_id"/>
    <AddressInputForm v-model="company.address_kanji" :kana="false" @setTempPostalCode="setTempPostalCode"/>
    <AddressInputForm v-model="company.address_kana" :kana="true"/>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import AddressInputForm from "@/components/objects/stripe/account/AddressInputForm";

  export default {
    name: "VerifyingCompany",
    components: {AddressInputForm},
    mixins: [collection],


    props: {
      company: {
        type: Object,
        required: true
      },
    },

    data() {
      return {
        office: null,
        companyName: ''
      }
    },

    watch: {
      companyName: {
        handler: function () {
        this.company.name = this.companyName;
        this.company.name_kanji = this.companyName;
        }
      },
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    async mounted() {
      await this.getDoc('userDetails', this.uid).then(async doc => {
        await this.getDoc('offices', doc.office.id).then(async doc => {
          this.office = doc;
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      this.companyName = this.office.name;
      this.company.phone = this.office.phoneNumber;
    },

    methods: {
      setTempPostalCode(postalCode){
        this.$emit('setTempPostalCode', postalCode)
      }
    }

  }
</script>

<style lang="scss" scoped>
  .verifying-company {
    .text_form, label {
      width: 100%;
    }
  }
</style>